import React from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../i18n/i18n";

function resolveLanguage(language) {
    return (language || "en").toLowerCase().startsWith("sv") ? "sv" : "en";
}

function SwedishFlag() {
    return (
        <svg viewBox="0 0 16 10" className="h-4 w-6 overflow-hidden rounded-sm" aria-hidden="true">
            <rect width="16" height="10" fill="#006AA7" />
            <rect x="5" width="2" height="10" fill="#FECC00" />
            <rect y="4" width="16" height="2" fill="#FECC00" />
        </svg>
    );
}

function BritishFlag() {
    return (
        <svg viewBox="0 0 60 30" className="h-4 w-6 overflow-hidden rounded-sm" aria-hidden="true">
            <rect width="60" height="30" fill="#012169" />
            <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
            <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4" />
            <path d="M30,0 V30 M0,15 H60" stroke="#fff" strokeWidth="10" />
            <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
        </svg>
    );
}

const FLAG_BY_CODE = {
    en: BritishFlag,
    sv: SwedishFlag,
};

function LanguageSwitcher() {
    const { i18n, t } = useTranslation();
    const current = resolveLanguage(i18n.resolvedLanguage || i18n.language);

    return (
        <div
            className="flex items-center gap-1"
            role="group"
            aria-label={t("header.language")}
        >
            {SUPPORTED_LANGUAGES.map(({ code, labelKey }) => {
                const isActive = current === code;
                const Flag = FLAG_BY_CODE[code];
                return (
                    <button
                        key={code}
                        type="button"
                        onClick={() => i18n.changeLanguage(code)}
                        className={
                            "flex h-8 w-10 items-center justify-center rounded-lg border transition-colors " +
                            (isActive
                                ? "border-primary-300 bg-primary-50 ring-1 ring-primary-200"
                                : "border-transparent hover:border-mute-200 hover:bg-primary-50")
                        }
                        aria-pressed={isActive}
                        aria-label={t(labelKey)}
                        title={t(labelKey)}
                    >
                        <Flag />
                    </button>
                );
            })}
        </div>
    );
}

export default LanguageSwitcher;
